
















































import {ObjectFactory} from '@/config/objectFactory';
import {MemberProfile} from '@/types/response';
import {MathUtils} from '@/util/mathUtils';
import {Component, Vue} from 'vue-property-decorator';
import ChangePaymentModal from './ChangePaymentModal.vue';
import AddPaymentModal from './AddPaymentModal.vue';
import {minValue, required} from 'vuelidate/lib/validators';
import {ApiRequest, PurchaseCreditsRequest} from '@/types/request';
import {MedTransGoConstants} from '@/util/constants';
import {EventBus} from '@/main';
import {ToastEvent} from '@/types/event';
import {CommonUtils} from '@/util/commonUtils';
import {RideCreditMethod} from '@/types/entity';

@Component({
    components: {
        ChangePaymentModal,
        AddPaymentModal,
    },
    data() {
        return {
            credit: 0,
            creditPointAmountInUSD: null,
        };
    },
    validations() {
        const validations = {
            credit: {
                required,
                minValue: minValue(0),
            },
        };
        return validations;
    },
})
export default class PurchaseCreditsModal extends Vue {
    private show = true;
    private perUnitAmount = '';
    private customerPaymentId = '';
    private memberProfile: MemberProfile = ObjectFactory.getCacheService().getMemberInfo();
    private paymentCustomerId: string = '';
    private paymentCustomer: any = '';
    private showAddPaymentForm = false;
    private showChangePaymentForm = false;
    private errorMessage = '';
    private rideCreditMethod: RideCreditMethod = null as any;
    private perCreditPrice: number = null as any;
    private totalCreditAmount = 0;
    private orgId = '';
    private showPaymentMethod = false;

    public async mounted() {
        const organization = await ObjectFactory.getOrganizationService().
            getOrgDetailsById(this.$store.state.serverUrl);
        if (organization && organization.data && organization.data.rideCreditMethod && organization.data.id) {
            this.orgId = organization.data.id;
            this.rideCreditMethod = organization.data.rideCreditMethod;
            if (this.rideCreditMethod === 'CREDIT_AMOUNT') {
                this.showPaymentMethod = true;
            } else {
                this.showPaymentMethod = false;
            }
        }
        if (organization.data &&
            (!organization.data.chequePaymentRequest || organization.data.chequePaymentRequest.status !== 'Approved')
                && this.showPaymentMethod) {
            this.getPaymentCustomer();
        }
        this.getPaymentCustomer();
    }
    private close() {
        this.$data.credit = 0;
        this.$emit('close');
        this.show = false;
    }

    private updateCreditAmount() {
        if (this.$data.credit >= 0) {
            this.totalCreditAmount = this.$data.credit * 100;
            this.$data.creditPointAmountInUSD =
                    MathUtils.formatCurrency(this.totalCreditAmount);
        } else {
            this.$data.credit = 0;
            this.totalCreditAmount = 0;
        }
    }

    private async getPaymentCustomer() {
        if (!this.customerPaymentId) {
            const memberResponse = await ObjectFactory.getMemberService().
                    getMemberDetails(this.$store.state.serverUrl, this.memberProfile.memberId);
            if (memberResponse.success && memberResponse.data && memberResponse.data.paymentCustomerId) {
                this.customerPaymentId = memberResponse.data.paymentCustomerId;
                this.paymentCustomerId = memberResponse.data.paymentCustomerId;
            } else {
                this.paymentCustomer = '';
                return;
            }
        }
        const response = await ObjectFactory.getPaymentSourceService()
            .getPaymentCustomer(this.$store.state.serverUrl, this.customerPaymentId);
        this.paymentCustomer = response.data;
    }

    private async purchaseCredits() {
        try {
            const iHttpService = ObjectFactory.getHttpService();
            const purchaseCreditRequest: PurchaseCreditsRequest = {
                amount: this.totalCreditAmount,
                noOfCredits: parseInt(this.$data.credit, 10),
            };
            if (this.rideCreditMethod === 'CREDIT_AMOUNT') {
                purchaseCreditRequest.paymentSource = this.paymentCustomer.defaultSource.id;
            }
            const apiRequest: ApiRequest = {
                baseURL: this.$store.state.serverUrl,
                url: `${MedTransGoConstants.HTTP_URL_ORGANIZATIONS}/${this.orgId}/rideCredit/purchase`,
                data: purchaseCreditRequest,
                loaderEvent: {
                    show: true,
                },
            };
            const response = await iHttpService.post<any>(apiRequest);
            if (response.success) {
                this.errorMessage = '';
                this.$emit('success');
                const toastEvent: ToastEvent = {
                    message: 'Credits have been purchased successfully.',
                    title: 'Success',
                    varient: 'success',
                    timeout: 5000,
                };
                EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
                this.close();
            } else if (response.errorCode) {
                this.errorMessage = CommonUtils.translateErrorCode(response.errorCode);
                const toastEvent: ToastEvent = {
                    message: CommonUtils.translateErrorCode(response.errorCode),
                    title: 'Error',
                    varient: 'danger',
                    timeout: 5000,
                };
                EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            }
        } catch (error) {
            this.errorMessage = error as any;
            const toastEvent: ToastEvent = {
                message: 'Error while purchase credits',
                title: 'Error',
                varient: 'danger',
                timeout: 5000,
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
        }
    }

}
